import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import * as layout from '../layout'
import { Button, LinkAsButton, styles as S } from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'
import * as modalActions from '../../../../actions/modal'

type ComingSoonProps = {
  project: projectModel.Project
  markStepSeen: () => Promise<void>
}

export function ComingSoon({ project, markStepSeen }: ComingSoonProps): React.ReactElement<ComingSoonProps> | null {
  const dispatch = Redux.useDispatch()
  const manager = project.manager || project.default_manager

  const [open, setIsOpen] = React.useState(true)

  if (manager === undefined) {
    return null
  }

  return (
    <layout.SimpleModal
      closable={true}
      open={open}
      onClose={handleDone}
      buttons={[
        {
          type: 'button',
          props: {
            onClick: openShareOverlay,
            children: t('Share my page'),
          },
        },
        {
          type: 'linkAsButton',
          props: {
            kind: 'secondary',
            onClick: handleDone,
            children: t('Later'),
          },
        },
      ]}
    >
      <S.heading.XXS>{t('Grow your fans list')}</S.heading.XXS>
      <S.copy.S>
        {t(
          'Did you know you can share a “Coming soon” version of your page where your community can already subscribe and get an email the day you launch!',
        )}
      </S.copy.S>
    </layout.SimpleModal>
  )

  function handleDone(): void {
    setIsOpen(false)
    markStepSeen()
  }

  function openShareOverlay(): void {
    dispatch(modalActions.toggleShareOverlay(true))
    handleDone()
  }
}

const CallToAction = styled(Button)`
  width: 100%;
`
